__turbopack_context__.v({
  "buttonLink": "IIFgRG_buttonLink",
  "container": "IIFgRG_container",
  "content": "IIFgRG_content",
  "img": "IIFgRG_img",
  "title": "IIFgRG_title",
});
